
class NotificationController {

  constructor($uibModalInstance, message) {
      this.message = message;
      this._$uibModalInstance = $uibModalInstance;
  }

  ok() {
      this._$uibModalInstance.close();
  }
}

NotificationController.$inject = ['$uibModalInstance', 'message'];

export default NotificationController;



// WEBPACK FOOTER //
// ./client/app/common/notification-modal.controller.js